module.exports = __webpack_public_path__ + "4c54119c8e09ccfb7f834af23a9ab09d.MP3";